import withVerticalSpacing from '../../hocs/withVerticalSpacing';
import { ESpotsSlide } from '../ESpotsSlide';
import { SimpleCarousel } from '../SimpleCarousel';

import { StyledContainer } from './ESpotsComponent.styled';
import { ESpotsComponentProperties } from './ESpotsComponent.types';

const ESpots = ({
    id,
    eSpots,
    slidesColor,
    textureColor,
}: ESpotsComponentProperties) => {
    const carouselSlides = eSpots.map((slide, index) => (
        <ESpotsSlide
            key={index}
            {...slide}
            slideColor={slidesColor}
            textureColor={textureColor}
            slidePosition={(index + 1).toString()}
            eSpotsCount={eSpots.length}
        />
    ));
    return (
        <StyledContainer id={id}>
            <SimpleCarousel
                galleryElements={carouselSlides}
                isNewDesign
                className="espots-carousel"
                areSlidesSameWidth
            />
        </StyledContainer>
    );
};

export const ESpotsComponent = withVerticalSpacing(ESpots);
